import React, { useEffect, useState } from 'react'
import {
  Container,
  Grid,
  makeStyles,
  Paper,
  Tab,
  Tabs,
  Typography,
} from '@material-ui/core'
import BestPharmaciesList from './pharmacy/bestPharmaciesList'
import AllWidgets from './widgets/AllWidgets'
import 'intro.js/introjs.css'
import 'intro.js/introjs-rtl.css'
import './style.css'
import { isPublicPanel } from 'utils'
import AddedValueOfPharmacyWidget from './widgets/AddedValueOfPharmacyWidget'
import AddedValueWidget from './widgets/AddedValueWidget'
import routes from 'routes'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Reports } from 'services/api'
import MenuButton from 'components/public/widget/MenuButton'
import { Declarations } from 'components/public'
import SubMenu from './people-components/SubMenu'
import MenuStatistic from 'components/public/widget/MenuStatistic'
import InfoView from 'components/public/widget/InfoView'
import { WidgetInterface } from 'interfaces'
import { Link } from 'react-router-dom'

const { getTopBestPharmacies } = new Reports()
const Map = styled.div`
  margin: 1rem auto;
  width: 100%;

  svg {
    stroke: #fff;

    // All layers are just path elements
    path {
      fill: #a82b2b;
      cursor: pointer;
      outline: none;

      // When a layer is hovered
      &:hover {
        fill: rgba(168, 43, 43, 0.83);
      }

      // When a layer is focused.
      &:focus {
        fill: rgba(168, 43, 43, 0.6);
      }

      // When a layer is 'checked' (via checkedLayers prop).
      &[aria-checked='true'] {
        fill: rgba(56, 43, 168, 1);
      }

      // When a layer is 'selected' (via currentLayers prop).
      &[aria-current='true'] {
        fill: rgba(56, 43, 168, 0.83);
      }
    }
  }
`

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  container: {
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
  userButton: {
    width: '140px',
    height: '140px',
    borderRadius: '70px',
    border: '5px solid',
    borderColor: '#1e88e5',
    padding: '0',
  },
  buttonText: {
    textAlign: 'center',
    margin: '10px 0',
    color: '#1e88e5',
  },
  buttonItem: {
    width: '140px',
    margin: 'auto',
  },
  buttonNavigator: {
    width: '100%',
    height: '140px',
    textDecoration: 'none',
    color: '#1e88e5',
  },
  userInfo: {
    height: '100px',
    marginTop: '-60px',
    background: '#3D2294',
    width: '100%',
    margin: '20px auto',
    color: '#FFF',
    borderRadius: '10px',
  },

  mainHeader: {
    fontWeight: 700,
    fontSize: '15px',
    lineHeight: '23px',
    textAlign: 'left',
    color: '#3D2294',
    position: 'relative',
    top: '-30px',
  },

  mainContent: {
    background: '#fff',
    borderRadius: '10px',
    height: '170px',
    paddingTop: '20px',
    paddingLeft: '60px',
    boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.15)',
    margin: '0px 6px',
  },

  activeIcon: {
    background: '#fff',
    borderRadius: '15px',
    padding: '10px',
    width: '78px',
  },

  overflowX: {
    '@media(max-width: 960px)': {
      overflowX: 'scroll',
      overflowY: 'hidden',
    },
  },

  extraWidth: {
    '@media(max-width: 960px)': {
      maxWidth: '304%',
      width: '350%',
    },
  },

  menuStatistic: {
    margin: '0px',
    borderRadius: '15px',
  },

  backClassName: {
    position: 'relative',
    opacity: '0.1',
    width: '150px',
    display: 'table',
    top: '-122px',
    right: '50px',
    marginLeft: '100px',
    '@media(max-width: 960px)': {
      right: '20vw',
    },
  },

  sideBarActive: {
    background:
      'linear-gradient(180deg, rgba(252, 113, 113, 0.8) 0%, rgba(242, 47, 47, 0.8) 52.08%)',
    boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.1)',
    borderRadius: '15px',
    height: '150px',
    margin: '15px 0.3%',
    width: '32.6%',
    '@media(max-width: 960px)': {
      width: '87vw',
    },
  },

  sideBarSearch: {
    background:
      'linear-gradient(180deg, rgba(55, 234, 159, 0.8) 0%, rgba(4, 171, 102, 0.8) 64.06%);',
    boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.1)',
    borderRadius: '15px',
    height: '150px',
    margin: '15px 0.3%',
    width: '32.6%',
    '@media(max-width: 960px)': {
      width: '87vw',
    },
  },

  sideBarSearchSuc: {
    background:
      'linear-gradient(180deg, rgba(68, 127, 215, 0.624) 0%, rgba(19, 91, 200, 0.8) 58.33%)',
    boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.1)',
    borderRadius: '15px',
    height: '150px',
    margin: '15px 0.3%',
    width: '32.6%',
    '@media(max-width: 960px)': {
      width: '87vw',
    },
  },

  commingSoonMain: {
    display: 'inline-block',
    color: '#fff',
    textAlign: 'center',
    top: '-28px',
    padding: '1px 5px',
    borderRadius: '10px',
    fontSize: '12px',
    fontWeight: 400,
    width: '0px',
    height: '0px',
    position: 'relative',
    right: '-18%',
    '@media(max-width: 960px)': {
      top: '-28px',
      right: '-30%',
    },
    '@media(max-width: 750px)': {
      top: '-48px',
      right: '0%',
    },
  },
  userInfoValue: {
    width: '50px',
    display: 'inline-block',
    height: '50px',
    margin: '0px 15px',
    fontWeight: 700,
    fontSize: '25px',
    lineHeight: '50px',
    background: '#644ea9',
    color: '#FFFFFF',
    boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.1)',
    borderRadius: '12px',
  },
  ribbonlarge: {
    background: '',
  },
  ribbon: {
    zIndex: 100,
    opacity: 0.9,
    width: '100%',
    height: '64px',
    overflow: 'hidden',
    top: -100,
    position: 'relative',
    // '&::before &::after': {
    //   position: 'absolute',
    //   zIndex: -1,
    //   content: '',
    //   display: 'block',
    //   border: '5px solid #2980b9',
    //   borderTopColor: 'transparent',
    //   borderLeftColor: 'transparent',
    // },
    // '&::before': {
    //   top: 0,
    //   left: 0,
    // },
    // '&::after': {
    //   bottom: 0,
    //   right: 0,
    // },
    '& span': {
      display: 'block',
      width: '225px',
      padding: '15px 0',
      backgroundColor: '#008D52',
      color: 'white',
      boxShadow: '0 5px 10px rgba(0,0,0,.1)',
      textShadow: '0 1px 1px rgba(0,0,0,.2)',
      textTransform: 'uppercase',
      textAlign: 'center',
      fontSize: 10,

      transform: 'rotate(45deg) !important',
      height: 30,
      margin: 5,
      // padding: 0,
      paddingLeft: 27,
      animation: '2s ease 0s infinite normal none running kCWFMR',
      float: 'left',

      right: -95,
      position: 'relative',
    },
  },
  primaryActions: {
    marginBottom: theme.spacing(1),
  },
  drugRequestHero: {
    position: 'relative',
    minHeight: '176px',
    height: '100%',
    display: 'flex',
    direction: 'rtl',
    alignItems: 'center',
    justifyContent: 'space-between',
    overflow: 'hidden',
    padding: theme.spacing(3, 4),
    color: '#fff',
    textDecoration: 'none',
    background: 'linear-gradient(135deg, #5634c7 0%, #321982 100%)',
    borderRadius: '16px',
    boxShadow: '0 12px 30px rgba(61, 34, 148, 0.28)',
    transition: 'transform 180ms ease, box-shadow 180ms ease',
    '&::after': {
      content: '""',
      position: 'absolute',
      width: '240px',
      height: '240px',
      left: '-70px',
      bottom: '-150px',
      border: '36px solid rgba(255, 255, 255, 0.06)',
      borderRadius: '50%',
    },
    '&:hover': {
      color: '#fff',
      textDecoration: 'none',
      transform: 'translateY(-2px)',
      boxShadow: '0 16px 34px rgba(61, 34, 148, 0.34)',
    },
    '&:focus': {
      color: '#fff',
      textDecoration: 'none',
      outline: '3px solid rgba(254, 207, 30, 0.7)',
      outlineOffset: '2px',
    },
    '@media(max-width: 600px)': {
      minHeight: '196px',
      padding: theme.spacing(2.5),
    },
    '@media(min-width: 960px)': {
      justifyContent: 'center',
    },
  },
  drugRequestContent: {
    position: 'relative',
    zIndex: 1,
    textAlign: 'left',
    '@media(max-width: 600px)': {
      flex: '1 1 0',
      minWidth: 0,
    },
  },
  drugRequestEyebrow: {
    display: 'block',
    marginBottom: theme.spacing(0.5),
    color: '#FECF1E',
    fontSize: '12px',
    fontWeight: 700,
  },
  drugRequestTitle: {
    margin: 0,
    fontFamily: 'VazirBold',
    fontSize: '28px',
    fontWeight: 700,
    lineHeight: 1.7,
    '@media(max-width: 600px)': {
      fontSize: '20px',
    },
  },
  drugRequestDescription: {
    display: 'block',
    marginBottom: theme.spacing(2),
    color: 'rgba(255, 255, 255, 0.82)',
    fontSize: '13px',
    lineHeight: 1.9,
  },
  drugRequestCta: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(1, 2.5),
    color: '#3D2294',
    background: '#FECF1E',
    borderRadius: '10px',
    fontSize: '13px',
    fontWeight: 700,
    boxShadow: '0 5px 14px rgba(20, 10, 62, 0.2)',
  },
  drugRequestIcon: {
    position: 'relative',
    zIndex: 1,
    flex: '0 0 auto',
    width: '108px',
    height: '108px',
    marginRight: theme.spacing(3),
    padding: theme.spacing(2),
    objectFit: 'contain',
    background: '#fff',
    borderRadius: '22px',
    boxShadow: '0 10px 24px rgba(20, 10, 62, 0.22)',
    '@media(min-width: 960px)': {
      marginRight: theme.spacing(7),
    },
    '@media(max-width: 600px)': {
      width: '64px',
      height: '64px',
      marginRight: theme.spacing(1),
      padding: theme.spacing(1),
      borderRadius: '14px',
    },
  },
  messagesCard: {
    height: '176px',
    margin: 0,
    '@media(max-width: 600px)': {
      height: '128px',
    },
  },
}))

const iconSize = '4x'

const { prescription, pharmacyMessage } = routes
const DashboardContent: React.FC<any> = () => {
  const classes = useStyles()
  const publicPanelActive = isPublicPanel()
  const { t } = useTranslation()
  const [value, setValue] = React.useState(0)
  const [code, setCode] = React.useState('')
  const [isOpenDetails, setIsOpenDetails] = useState(false)
  const [isRankingLoading, setIsRankingLoading] = useState<boolean>(true)
  const [widgetData, setWidgetData] = useState<WidgetInterface[]>()

  const { getWidgetCounter } = new Reports()

  useEffect(() => {
    async function getWidgetData() {
      const result = await getWidgetCounter()
      setWidgetData(result)
    }
    getWidgetData()
  }, [])

  const getKeyData = (key: string): number => {
    if (widgetData) {
      for (const widgetInfo of widgetData) {
        if (widgetInfo.name === key) {
          return widgetInfo.value ? Number(widgetInfo.value) : 0
        }
      }
    }
    return 0
  }
  // const { data, refetch } = useQuery(
  //   ['getTopBestPharmacies', code],
  //   () => {
  //     return getTopBestPharmacies(code)
  //   },
  //   { enabled: code },
  // )

  // useEffect(() => {
  //   setIsRankingLoading(false)
  // }, [data])

  const handleChange = (event: any, newValue: any): void => {
    setValue(newValue)
  }

  //   const handleChangeIndex = (index: any): void => {
  //     setValue(index)
  //   }
  //   const onClick = ({ target }: any) => {
  //     setCode(target.id)
  //     setIsOpenDetails(true)
  //     setIsRankingLoading(true)
  //     // const name = target.attributes.name.value;
  //     // window.open(`https://www.google.com/search?q=${name}%20nz`);
  //   }

  //   const rankingDialogClose = () => {
  //     setIsOpenDetails(false)
  //     setIsRankingLoading(true)
  //   }

  //   const rankingDialogOpen = () => {
  //     setIsOpenDetails(true)
  //     setIsRankingLoading(true)
  //  }

  // const rankingPharmaciesTableColumns = useMemo((): DataTableColumns[] => {
  //   return [
  //     {
  //       field: 'name',
  //       title: t('pharmacy.pharmacy'),
  //       type: 'string',
  //     },
  //     {
  //       field: 'city',
  //       title: t('pharmacy.city'),
  //       type: 'string',
  //     },
  //     {
  //       field: 'star',
  //       title: t('pharmacy.star'),
  //       type: 'string',
  //       render: (row: any) => {
  //         return <>{Stars(+row.star)}</>
  //       },
  //     },
  //   ]
  // }, [])

  // /// RANKING DROPDOWN
  // const [provinces, setProvinces] = useState <LabelValue[]>([{
  //   label: '',
  //   value: '-1'
  // }])

  // const { getAllProvinces } = new CountryDivision()
  // useEffect(() => {
  //   async function getProvinces() {
  //     const result = await getAllProvinces()
  //     const gottenProvinces: LabelValue[] = []

  //     for (let pi = 0; pi < result.items.length; pi++) {
  //       const element: LabelValue = {
  //         label: result.items[pi].name,
  //         value: result.items[pi].code
  //       }
  //       gottenProvinces.push(element)
  //     }
  //     setProvinces(gottenProvinces)
  //   }
  //   getProvinces()
  // }, [])

  const onRankingDropDownChanged = (value: any) => {
    setCode(value)
    setIsOpenDetails(true)
    setIsRankingLoading(true)
    // const name = target.attributes.name.value;
    // window.open(`https://www.google.com/search?q=${name}%20nz`);
  }
  /// END of RANKING DROPDOWN
  const user = JSON.parse(localStorage.getItem('user') || '{}')

  return (
    <div style={{ maxWidth: '1100px', margin: '0px auto' }}>
      <Container maxWidth="lg" className={classes.container}>
        <Typography component="div" variant="body1"></Typography>
        <Declarations />
        {publicPanelActive && (
          <>
            <SubMenu />
          </>
        )}
        {publicPanelActive && (
          <>
            <Grid
              container
              xs={12}
              spacing={1}
              className={classes.primaryActions}
            >
              <Grid item xl={9} lg={9} md={9} sm={8} xs={12}>
                <Link to={prescription} className={classes.drugRequestHero}>
                  <div className={classes.drugRequestContent}>
                    <span className={classes.drugRequestEyebrow}>
                      سریع و ساده
                    </span>
                    <h1 className={classes.drugRequestTitle}>
                      {t('peopleSection.drugRequest')}
                    </h1>
                    <span className={classes.drugRequestDescription}>
                      درخواست خود را ثبت کنید تا برای داروخانه‌ها ارسال شود.
                    </span>
                    <span className={classes.drugRequestCta}>
                      ثبت درخواست جدید
                    </span>
                  </div>
                  <img
                    className={classes.drugRequestIcon}
                    src="/images/ReqDrug.png"
                    alt=""
                  />
                </Link>
              </Grid>
              <Grid
                item
                xl={3}
                lg={3}
                md={3}
                sm={4}
                xs={12}
                className="text-center"
              >
                <MenuButton
                  className={`task-grid ${classes.messagesCard}`}
                  data={{
                    icon: <img src="/images/messages.png" />,
                    title: t('peopleSection.messages'),
                    link: pharmacyMessage,
                  }}
                />
              </Grid>
            </Grid>
            {/* Statistics cards are temporarily hidden and kept for future use.
            <div className={classes.overflowX}>
              <Grid container xs={12} className={classes.extraWidth}>
                <Grid item className={classes.sideBarActive}>
                  <MenuStatistic
                    data={{
                      icon: (
                        <img
                          className={classes.activeIcon}
                          src="/images/active.png"
                        />
                      ),
                      backIcon: (
                        <img
                          className={classes.backClassName}
                          src="/images/active.png"
                        />
                      ),
                      title: t('peopleSection.drugRequest'),
                      link: prescription,
                    }}
                    className={classes.menuStatistic}
                    number={getKeyData('Pharmacy')}
                    title="داروخـــــانه فعال"
                    subtitle="عضو داروگ"
                  />
                </Grid>
                <Grid item className={classes.sideBarSearch}>
                  <MenuStatistic
                    data={{
                      icon: (
                        <img
                          className={classes.activeIcon}
                          src="/images/search.png"
                        />
                      ),
                      backIcon: (
                        <img
                          className={classes.backClassName}
                          src="/images/search.png"
                        />
                      ),
                      title: t('peopleSection.drugRequest'),
                      link: prescription,
                    }}
                    className={classes.menuStatistic}
                    number={getKeyData('User')}
                    title="بازدیـــد کننده"
                    subtitle="در سامانه ی داروگ"
                  />
                </Grid>
                <Grid item className={classes.sideBarSearchSuc}>
                  <MenuStatistic
                    data={{
                      icon: (
                        <img
                          className={classes.activeIcon}
                          src="/images/sucSearch.png"
                        />
                      ),
                      backIcon: (
                        <img
                          className={classes.backClassName}
                          src="/images/sucSearch.png"
                        />
                      ),
                      title: t('peopleSection.drugRequest'),
                      link: prescription,
                    }}
                    className={classes.menuStatistic}
                    number={getKeyData('Search')}
                    title="جستجوی موفق"
                    subtitle="در سامانه ی داروگ"
                  />
                </Grid>
              </Grid>
            </div>
            */}
            <InfoView />
            {/* <Paper className={classes.paper} style={{
            background: '#999',
            borderRadius: '10px'
          }}>

            <Grid
              item
              xs={12}
              container
              spacing={3}
              className="speed-dial-container"
            >
              <Grid item xs={6} sm={3} md={2} xl={2}>
                <MenuButton
                  data={{
                    icon: <FontAwesomeIcon icon={faUser} size={iconSize} />,
                    title: t('user.profile'),
                    link: profile,
                  }}
                  iconClassName="speed-dial-colored"
                />
              </Grid>
              <Grid item xs={6} sm={3} md={2} xl={2}>
                <MenuButton
                  data={{
                    icon: (
                      <FontAwesomeIcon icon={faFileMedical} size={iconSize} />
                    ),
                    title: t('peopleSection.prescription'),
                    link: prescription,
                  }}
                  iconClassName="speed-dial-colored"
                />
              </Grid>
              <Grid item xs={6} sm={3} md={2} xl={2}>
                <MenuButton
                  data={{
                    icon: <FontAwesomeIcon icon={faBars} size={iconSize} />,
                    title: t('peopleSection.jobApplication'),
                    link: jobApplication,
                  }}
                  iconClassName="speed-dial-colored"
                />
              </Grid>
            </Grid>
          </Paper> */}
          </>
        )}
        {!publicPanelActive && (
          <Grid container spacing={3}>
            {/* <DaroogSpeedDials /> */}
            {/* Widgets */}
            <AllWidgets />
            <Grid item xs={12} container spacing={3}>
              <Grid item xs={12} sm={12} md={6} xl={6}>
                <AddedValueOfPharmacyWidget />
              </Grid>
              <Grid item xs={12} sm={12} md={6} xl={6}>
                <AddedValueWidget />
              </Grid>
            </Grid>

            {/* Chart */}
            {/* <Grid
            item
            xs={12}
            sm={12}
            md={6}
            xl={6}
            style={{ height: 500, overflow: 'disabled' }}
          >
            <Paper
              className={classes.paper}
              style={{ height: 500, overflow: 'disabled' }}
            >
              <span>هیت مپ تبادلات در کشور</span>
              <div id="map">
                <MapCluster />
              </div>
            </Paper>
          </Grid> */}
            {/* <Grid item xs={12} sm={12} md={6} xl={6}>
            <Paper className={classes.paper} style={{ height: 500 }}>
              <span>{t('reports.allExchangesChart')}</span>
              <ExChangeChart />
            </Paper>
          </Grid> */}
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                  aria-label="full width tabs example"
                >
                  <Tab label="داروخانه‌های برتر روزانه و نیمه وقت " />
                  <Tab label="داروخانه‌های برتر شبانه روزی" />
                </Tabs>
                <div style={{ marginTop: '5px' }}>
                  {value === 0 ? (
                    <BestPharmaciesList for24Hour={false}></BestPharmaciesList>
                  ) : (
                    <BestPharmaciesList for24Hour={true}></BestPharmaciesList>
                  )}
                </div>
              </Paper>
            </Grid>
            {/* <Grid item xs={12}>
            <h3>
              {t('general.rankingMapTitle')}
              <br />
              <span className="text-muted">
                { t('general.rankingDropdownSubtitle')}
              </span>
            </h3>
            <Grid item xs={6}>
              <DaroogDropdown
                className="w-100"
                defaultValue="-1"
                onChangeHandler={ onRankingDropDownChanged }
                data={ provinces }
              />
            </Grid>
            {/* <Map>
              <VectorMap {...iran} layerProps={{ onClick }} />
            </Map>
          </Grid> */}
          </Grid>
        )}
        {/* <CDialog
        fullScreen={false}
        fullWidth
        isOpen={isOpenDetails}
        onClose={ rankingDialogClose }
        onOpen={ rankingDialogOpen }
        hideSubmit={true}
      >
        <DialogTitle>
          {t('pharmacy.pharmacies')}
          {data && data.items && data.items[0] ? (
            <>
              {'ی ' + t('pharmacy.province') + ' '}
              {<b>{data.items[0].province}</b>}
            </>
          ) : (
            ''
          )}
        </DialogTitle>
        <Divider />
        <DialogContent>
          { isRankingLoading && <CircleLoading /> }
          {data && data.items && (
            <DataGrid
              tableColumns={rankingPharmaciesTableColumns}
              data={data.items}
              isLoading={isRankingLoading}
            />
          )}
        </DialogContent>
      </CDialog> */}
      </Container>
    </div>
  )
}

export default DashboardContent
